export default "__VITE_ASSET__10bed0ad__"